import { makeStyles } from 'tss-react/mui';
import { P2GBox, P2GCardContainer, P2GDivider, P2GGrid, useP2GMediaQueryOnly } from '@parcel2go/core-ui';

const useStyles = makeStyles()({
  root: {
    // The card comes with padding but the prices need to span full width
    '& > .MuiCardContent-root': {
      padding: '0 !important'
    }
  }
});

type props = {
  wrapper: (c: React.ReactNode) => React.ReactNode;
  title: React.ReactNode;
  left: React.ReactNode;
  right: React.ReactNode;
  dataTestId: string;
};

const BasketItemContainer = ({ wrapper, title, left, right, dataTestId }: props) => {
  const { classes } = useStyles();
  const isXs = useP2GMediaQueryOnly('xs');

  return wrapper(
    <P2GCardContainer classNames={[classes.root]} dataTestId={dataTestId}>
      <P2GBox className={'card-grey'} p={isXs ? 3 : 4}>
        {title}
      </P2GBox>
      <P2GBox sx={{ p: { xs: 3, sm: 4 } }}>
        <P2GGrid container sx={{ gap: { xs: 2, sm: 0 } }}>
          <P2GGrid item sx={{ width: { xs: '100%', sm: 'calc(50% - 1px)' } }}>
            <P2GBox sx={{ pr: { xs: 0, sm: 4 }, pt: { sm: 1 } }}>{left}</P2GBox>
          </P2GGrid>
          {!isXs && (
            <P2GGrid item sx={{ width: '2px', display: 'flex' }}>
              <P2GDivider className="item-divider" orientation="vertical" variant="fullWidth" />
            </P2GGrid>
          )}
          <P2GGrid item sx={{ width: { xs: '100%', sm: 'calc(50% - 1px)' } }}>
            <P2GBox sx={{ pl: { xs: 0, sm: 4 }, pt: { sm: 1 } }}>{right}</P2GBox>
          </P2GGrid>
        </P2GGrid>
      </P2GBox>
    </P2GCardContainer>
  );
};
export default BasketItemContainer;
